import React, { FC } from 'react'

import SolidsportLogo from '../assets/images/Solid_Logotype.png'
import BasicHeader from '../components/page/basicHeader/Header'
import { Header } from '../components/page/header/index'
import { TopSpacer } from './TopSpacer'
import { AccountHeader } from 'components/page/header/AccountHeader/AccountHeader'
import { ConditionalRender } from 'components/ConditionalRender/ConditionalRender'
import { NavigationHeaderPreloader } from 'components/page/header/components/NavigationHeaderPreloader'
import { NativeAccountHeader } from 'components/page/header/AccountHeader/NativeAccountHeader'

interface Props {
  showBasicHeader: boolean
  showAccountHeader: boolean
  addTopSpacer: boolean
  isRootOrChild: boolean
  isRootClubChannel: boolean
  isViewingStream?: boolean
  isLoading: boolean
}

export const AppHeader: FC<Props> = ({
  showBasicHeader,
  showAccountHeader,
  addTopSpacer,
  isRootOrChild,
  isRootClubChannel,
  isViewingStream = false,
  isLoading
}) => {
  if (isLoading) {
    return <NavigationHeaderPreloader />
  }
  if (isViewingStream) {
    return null
  }
  return (
    <>
      {showBasicHeader && !showAccountHeader && (
        <BasicHeader headerImgPath={SolidsportLogo} />
      )}
      <ConditionalRender mobileApp={false} web={showAccountHeader}>
        <AccountHeader />
      </ConditionalRender>
      <ConditionalRender mobileApp={showAccountHeader} web={false}>
        <NativeAccountHeader />
      </ConditionalRender>
      {!showBasicHeader && !showAccountHeader && <Header />}
      {addTopSpacer && (
        <TopSpacer
          isRootClubChannel={isRootClubChannel}
          isRootOrChild={isRootOrChild}
        />
      )}
    </>
  )
}
